import { apiClient } from "../../../api/client";
import {
  AvisoFiltro,
  AvisoLote,
  AvisoMenu,
  AvisoPrevia,
  FilaStatus,
  MagicLink,
  Message,
  Page,
  Ticket,
  TicketMessages,
} from "../types";

const ENDPOINT = "/gestorSuporte";

/**
 * Tudo passa pelo gestorSuporte, que autentica o atendente e repassa para a API
 * privada do chatwoot. `apiClient.post` já desembrulha o `{ data }` da resposta.
 *
 * `ops_entregador` (e não `ops`) porque o apiClient injeta em todo POST a ops
 * selecionada no gestor, que não é a ops do entregador.
 */
export const suporteService = {
  fila: (status: FilaStatus, cursor?: string | null) =>
    apiClient.post<Page<Ticket>>(ENDPOINT, { acao: "fila", status, limit: 100, cursor }),

  ticket: (ticketId: string) => apiClient.post<Ticket>(ENDPOINT, { acao: "ticket", ticket_id: ticketId }),

  mensagens: (ticketId: string) =>
    apiClient.post<TicketMessages>(ENDPOINT, { acao: "mensagens", ticket_id: ticketId }),

  responder: (ticketId: string, body: string, clientMsgId: string) =>
    apiClient.post<{ items: Message[] }>(ENDPOINT, {
      acao: "responder",
      ticket_id: ticketId,
      body,
      client_msg_id: clientMsgId,
    }),

  encerrar: (ticketId: string) => apiClient.post<Ticket>(ENDPOINT, { acao: "encerrar", ticket_id: ticketId }),

  historico: (contactId: string, cursor?: string | null) =>
    apiClient.post<Page<Message>>(ENDPOINT, { acao: "historico", contact_id: contactId, cursor }),

  gerarLink: (telefone: string, opsEntregador: string) =>
    apiClient.post<MagicLink>(ENDPOINT, { acao: "gerar_link", telefone, ops_entregador: opsEntregador }),

  avisoMenus: () => apiClient.post<{ items: AvisoMenu[] }>(ENDPOINT, { acao: "aviso_menus" }),

  avisoPrevia: (filtro: AvisoFiltro) => apiClient.post<AvisoPrevia>(ENDPOINT, { acao: "aviso_previa", ...filtro }),

  // Um lote do aviso. O `broadcast_id` é o mesmo em todos os lotes (e nas novas
  // tentativas) do mesmo aviso: o chatwoot não repete a mensagem num ticket.
  avisoEnviar: (filtro: AvisoFiltro, body: string, broadcastId: string, cursor?: string | null) =>
    apiClient.post<AvisoLote>(ENDPOINT, {
      acao: "aviso_enviar",
      ...filtro,
      body,
      broadcast_id: broadcastId,
      cursor: cursor ?? undefined,
    }),
};
